import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, SectionHead } from "src/components/common"
import { Grid, Card } from "./styles"

export const Quotes = () => {
  const { t } = useTranslation()
  const items = t("quotes:items", { returnObjects: true })

  return (
    <Section id="testimonials" aria-labelledby="quotes-title" $tone="soft">
      <Container>
        <SectionHead
          id="quotes-title"
          title={t("quotes:headline")}
          lead={t("quotes:lead")}
        />
        <Grid>
          {items.map((item, index) => (
            <Card key={index}>
              <blockquote lang={item.lang}>
                <p>{item.quote}</p>
              </blockquote>
              <figcaption>
                <strong>{item.name}</strong>
                <span>{item.company}</span>
                {item.translated ? (
                  <small>{t("quotes:translated_note")}</small>
                ) : null}
              </figcaption>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}
